import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';

import { UsuarioComponent, CrudUsuarioComponent } from './usuario/';
import { CrudAlterarSenhaComponent } from './alterar-senha/';
import { ModulosComponent } from './modulos/';
// import { CrudModulosComponent } from './modulos/';
import { LotacaoComponent, CrudLotacaoComponent } from './lotacao/';
import { LotacaoUsuarioComponent, CrudLotacaoUsuarioComponent } from './lotacao-usuario/';
import { PerfilComponent, CrudPerfilComponent } from './perfil/';
import { SistemaComponent, CrudSistemaComponent } from './sistema/';
import { FuncionalidadeComponent, CrudFuncionalidadeComponent } from './funcionalidade/';
import { FuncionalidadePerfilComponent, CrudFuncionalidadePerfilComponent } from './funcionalidade-perfil/';
import { FuncionalidadeAcaoComponent, CrudFuncionalidadeAcaoCrudComponent } from './funcionalidade-acao/';
import { AcaoComponent, CrudAcaoComponent } from './acao/';
import { MinhasPermissoesComponent, CrudMinhasPermissoesComponent } from './minhas-permissoes/';
import { GerenciarPermissoesComponent, CrudGerenciarPermissoesComponent } from './gerenciar-permissoes/';
import { PermissoesPendentesComponent, CrudPermissoesPendentesComponent } from './permissoes-pendentes';

import { AuthGuard } from './autenticacao/auth.guard';
import { Erro403Component } from './erros';
import { CentralNotificacaoComponent, CrudCentralNotificacaoComponent } from './central-notificacao';
import { CrudTrilhaAuditoriaComponent, TrilhaAuditoriaComponent } from './trilha-auditoria';
import { TipoUsuario } from './entity/enumeraveis';

export const routes: Routes = [
  { path: 'erro/403', data: { Breadcrumb: "403", Menu: "Erro" }, component: Erro403Component },
  {
    path: '', canActivate: [AuthGuard], children: [
      { path: '', redirectTo: 'sistema/modulos', pathMatch: 'full' },
      {
        path: 'usuarios', canActivateChild: [AuthGuard], children: [
          {
            path: 'usuario-externo', data: { possui: "externo", tipo: TipoUsuario.Externo, Breadcrumb: "Usuário Externo", Menu: "Usuários" },
            children: [
              { path: '', component: UsuarioComponent },
              { path: ':acao', component: CrudUsuarioComponent },
              { path: ':acao/:id', component: CrudUsuarioComponent }
            ]
          },
          {
            path: 'usuario-interno', data: { possui: "interno", tipo: TipoUsuario.Interno, Breadcrumb: "Usuário Interno", Menu: "Usuários" },
            children: [
              { path: '', component: UsuarioComponent },
              { path: ':acao', component: CrudUsuarioComponent },
              { path: ':acao/:id', component: CrudUsuarioComponent }
            ]
          },
          {
            path: 'alterar-senha', data: { Breadcrumb: "Alterar Senha", Menu: "Usuários" },
            children: [
              { path: '', component: CrudAlterarSenhaComponent },
              { path: ':acao', component: CrudAlterarSenhaComponent },
              { path: ':acao/:id', component: CrudAlterarSenhaComponent }
            ]
          },
          {
            path: 'lotacao-usuario', data: { tipo: 1, Breadcrumb: "Usuário Lotação", Menu: "Usuários" }, 
            children: [
              { path: '', component: LotacaoUsuarioComponent },
              { path: ':acao', component: CrudLotacaoUsuarioComponent },
              { path: ':acao/:id', component: CrudLotacaoUsuarioComponent }
            ]
          },
        ]
      },

      {
        path: 'sistema', canActivateChild: [AuthGuard], children: [
          {
            path: 'modulos', data: { Breadcrumb: "Página Inicial", Menu: "Sistema" }, 
            children: [
              { path: '', component: ModulosComponent },
              { path: ':acao', component: ModulosComponent },
              { path: ':acao/:id', component: ModulosComponent }
            ]
          },
          {
            path: 'sistemas', data: { Breadcrumb: "Sistemas", Menu: "Sistema" }, 
            children: [
              { path: '', component: SistemaComponent },
              { path: ':acao', component: CrudSistemaComponent },
              { path: ':acao/:id', component: CrudSistemaComponent }
            ]
          },
          {
            path: 'perfil', data: { Breadcrumb: "Perfil", Menu: "Sistema" }, 
            children: [
              { path: '', component: PerfilComponent },
              { path: ':acao', component: CrudPerfilComponent },
              { path: ':acao/:id', component: CrudPerfilComponent }
            ]
          },
          {
            path: 'acoes', data: { Breadcrumb: "Ações", Menu: "Sistema" }, 
            children: [
              { path: '', component: AcaoComponent },
              { path: ':acao', component: CrudAcaoComponent },
              { path: ':acao/:id', component: CrudAcaoComponent }
            ]
          },
          {
            path: 'funcionalidade', data: { Breadcrumb: "Funcionalidade", Menu: "Sistema" }, 
            children: [
              { path: '', component: FuncionalidadeComponent },
              { path: ':acao', component: CrudFuncionalidadeComponent },
              { path: ':acao/:id', component: CrudFuncionalidadeComponent }
            ]
          },
          {
            path: 'funcionalidade-perfil', data: { Breadcrumb: "Perfil Funcionalidade Ação", Menu: "Sistema" }, 
            children: [
              { path: '', component: FuncionalidadePerfilComponent },
              { path: ':acao', component: CrudFuncionalidadePerfilComponent },
              { path: ':acao/:id', component: CrudFuncionalidadePerfilComponent }
            ]
          },
          {
            path: 'lotacao', data: { Breadcrumb: "Lotação", Menu: "Sistema" }, 
            children: [
              { path: '', component: LotacaoComponent },
              { path: ':acao', component: CrudLotacaoComponent },
              { path: ':acao/:id', component: CrudLotacaoComponent }
            ]
          },
          {
            path: 'central-notificacao', data: { Breadcrumb: "Central de Notificações", Menu: "Sistema" }, 
            children: [
              { path: '', component: CentralNotificacaoComponent },
              { path: ':acao', component: CrudCentralNotificacaoComponent },
              { path: ':acao/:id', component: CrudCentralNotificacaoComponent }
            ]
          },
          {
            path: 'trilha-auditoria', data: { Breadcrumb: "Auditoria", Menu: "Sistema" }, 
            children: [
              { path: '', component: TrilhaAuditoriaComponent },
              { path: ':acao', component: CrudTrilhaAuditoriaComponent },
              { path: ':acao/:id', component: CrudTrilhaAuditoriaComponent }
            ]
          },
        ]
      },

      {
        path: 'permissoes', canActivateChild: [AuthGuard], children: [
          {
            path: 'minhas-permissoes', data: { Breadcrumb: "Minhas Permissões", Menu: "Permissões" }, 
            children: [
              { path: '', component: MinhasPermissoesComponent },
              { path: ':acao', component: CrudMinhasPermissoesComponent },
              { path: ':acao/:id', component: CrudMinhasPermissoesComponent }
            ]
          },
          {
            path: 'gerenciar-permissoes', data: { Breadcrumb: "Gerenciar Permissões", Menu: "Permissões" }, 
            children: [
              { path: '', component: GerenciarPermissoesComponent },
              { path: ':acao', component: CrudGerenciarPermissoesComponent },
              { path: ':acao/:id', component: CrudGerenciarPermissoesComponent }
            ]
          },
          {
            path: 'permissoes-pendentes', data: { Breadcrumb: "Permissões Pendentes", Menu: "Permissões" }, 
            children: [
              { path: '', component: PermissoesPendentesComponent },
              { path: ':acao', component: CrudPermissoesPendentesComponent },
              { path: ':acao/:id', component: CrudPermissoesPendentesComponent }
            ]
          },
        ]
      },
    ]
  },
];

export const AppRoutes: ModuleWithProviders = RouterModule.forRoot(routes);


// WEBPACK FOOTER //
// ./src/app/app.routes.ts